module.exports = __webpack_public_path__ + "components/flag/static/square/ps-cd973f49ba27965b10a4d78ed4ad63d6.svg";